module.exports = __webpack_public_path__ + "static/media/white-flite.9d0df073.svg";